import { gql } from '@parkchirp/api-client';

export const GET_AUDIT_HISTORY_CLOUD_WATCH_LINK_V2 = gql`
    query getAuditHistoryCloudWatchLink(
        $xrayTraceId: String!
    ) {
        getAuditHistoryCloudWatchLink(
            xrayTraceId: $xrayTraceId
        ) {
            url
        }
    }
`;

export const LIST_AUDIT_HISTORY_V2 = gql`
    query getResourceAuditHistory(
        $resourceId: String!
        $resourceType: String!    
    ) {
        getResourceAuditHistory(
            resourceId: $resourceId
            resourceType: $resourceType
        ) {
            history {
                id,
                time,
                resourceAction,
                userActionDescription,
                userId
                xrayTraceId
            },
            users {
                cognitoSub,
                firstName,
                lastName,
                email
            },
            fullHistory
        }
    }
`;
